import { success, failure, invalid } from "./helpers";
import {
  GETROLE,
  GETCLIENTROLES,
  SENDINVITE,
  SENDCLIENTINVITE,
  SET_STATUS_TO_FALSE,
  GET_TABLE_LIST,
  UPDATE_PROFILE,
  ROLLBACK_UPDATE_STATUS,
  UPDATE_ROLE,
  SUSPEND_USER,
  CLIENT_ASSIGNMENTS,
  REASSIGN_ACCOUNT_MANAGER,
  REASSIGN_ROLL_BACK,
  TEAM_MEMBER_OPTIONS,
  ACCOUNT_MANAGER,
  CLEAR_SUSPEND_ERROR,
} from "../actions/employees";

const initialState = {
  roles: [],
  clientRoles: [],
  ifSendInviteSuccess: false,
  tableList: {},
  ifUpdateSuccess: false,
  updateErrorText: '',
  sendInvite_error_message: '',
  ifUpdateRoleSuccess: false,
  client_assignments: [],
  ifReassignSuccess: false,
  suspend_error: '',
  client_assignments_error: '',
  team_member_options: [],
  account_manager: []
}

const employees = (state=initialState, action) => {
  switch(action.type) {
    case success(GETROLE):
      return {
        ...state,
        roles: action.payload
      }
    case success(GETCLIENTROLES):
      return {
        ...state,
        clientRoles: action.payload
      }
    case success(ACCOUNT_MANAGER):
      return {
        ...state,
        account_manager: action.payload
      }
    case success(SENDINVITE):
      return {
        ...state,
        ifSendInviteSuccess: true,
        sendInvite_error_message: ''
      }
    case invalid(SENDINVITE):
      return {
        ...state,
        sendInvite_error_message: action.payload.message
      }
    case failure(SENDINVITE): {
      return {
        ...state,
        sendInvite_error_message: action.payload.message
      }
    }
    case success(SENDCLIENTINVITE):
      return {
        ...state,
        ifSendInviteSuccess: true,
        sendInvite_error_message: ''
      }
    case invalid(SENDCLIENTINVITE):
      return {
        ...state,
        sendInvite_error_message: action.payload.message
      }
    case SET_STATUS_TO_FALSE:
      return {
        ...state,
        ifSendInviteSuccess: action.value,
        sendInvite_error_message: null
      }
    case success(GET_TABLE_LIST):
      return {
        ...state,
        tableList: action.payload
      }
    case success(UPDATE_PROFILE):
      return {
        ...state,
        ifUpdateSuccess: true,
        updateErrorText: ''
      }
    case failure(UPDATE_PROFILE):
      return {
        ...state,
        updateErrorText: action.payload.message
      }
    case invalid(UPDATE_PROFILE):
      return {
        ...state,
        updateErrorText: action.payload.message
      }
    case ROLLBACK_UPDATE_STATUS:
      return {
        ...state,
        ifUpdateSuccess: action.value,
        ifUpdateRoleSuccess: action.value
      }
    case success(UPDATE_ROLE):
      return {
        ...state,
        ifUpdateRoleSuccess: true
      }
    case success(SUSPEND_USER):
      window.location.reload();
      return {
        ...state
      }
    case invalid(SUSPEND_USER):
      return {
        ...state,
        suspend_error: action.payload.message
      }
    case CLEAR_SUSPEND_ERROR:
      return {
        ...state,
        suspend_error: ''
      }
    case success(CLIENT_ASSIGNMENTS):
      return {
        ...state,
        client_assignments: action.payload,
        client_assignments_error: ''
      }
    case invalid(CLIENT_ASSIGNMENTS):
      return {
        ...state,
        client_assignments_error: 'You are not a account manager'
      }
    case success(REASSIGN_ACCOUNT_MANAGER):
      return {
        ...state,
        ifReassignSuccess: true
      }
    case REASSIGN_ROLL_BACK:
      return {
        ...state,
        ifReassignSuccess: false
      }
    case TEAM_MEMBER_OPTIONS:
      return {
        ...state,
        team_member_options: action.payload
      }
    default:
      return state
  }
}

export default {
  employees
}


// WEBPACK FOOTER //
// ./src/reducers/employees.js